import { Locality } from "./localities.model";
import { Commercial } from "./commercials.model";
import { Tiers } from "./tiers.model";
import { TypeProject } from "./type-projects.model";
import { StateProject } from "./state-projects.model";
import { Site } from "./sites.model";
import { Lotissement } from "./lotissement.model";

export class Project {
    id: number;
    name: string;
    description: string;
    status: string;
    segment: string;
    surface: string;
    trSurface: string;
    createAt: Date;
    businessNumber: string;
    locality: Locality;
    commercials: Commercial[];
    tiers: Tiers[];
    typeProject: TypeProject;
    stateProject: StateProject;
    siteProject: Site;
    das : string[];
    caEstime: number;
    va1: number;
    va2: number;
    va3: number;
    va4: number;
    projectLotissement: Lotissement;
    closedAt : Date;

    constructor() {
        this.va1 = 0;
        this.va2 = 0;
        this.va3 = 0;
        this.va4 = 0;
        this.locality = new Locality();
        this.stateProject = new StateProject();
        this.typeProject = new TypeProject();
        this.siteProject = new Site();
        this.projectLotissement = new Lotissement();
    }
}


export class ProjectForm {
    id: number;
    name: string;
    description: string;
    status: string;
    segment: string;
    surface: string;
    trSurface: string;
    createAt: Date;
    businessNumber: string;
    locality: Locality;
    commercials: number[];
    tiers: number[];
    typeProject: number;
    stateProject: number;
    siteProject: number;
    das : string[];
    caEstime: number;
    va1: number;
    va2: number;
    va3: number;
    va4: number;
    projectLotissement: number;
    closedAt: Date;

    constructor() { }
}